import React from 'react';
import ButtonDialog from 'components/button-dialog';
import styles from 'feature/license-plates/index.module.scss';
import { useLicensePlateContext, CLOSE_DIALOG } from 'feature/license-plates/use-license-plate';
import { vehicleCarTypes } from 'feature/license-plates/license-plate-item';
import { useAppContext } from 'use-app';
import amplitude from 'service/amplitude';
import { getUserInfo } from 'helpers/data-check-helper';

const LicensePlateDialog = ({ isShow = false, licensePlate }) => {
  const { state, dispatch } = useLicensePlateContext();
  const { state: appState } = useAppContext();
  const { hasPayments } = getUserInfo(appState);

  const close = () => {
    amplitude.plateNumber_window_cancel_onClick();
    dispatch({ type: CLOSE_DIALOG });
  };

  const taipeiCityParkinglotBinding = bindingState => {
    if (bindingState === 'processing') {
      return (
        <div className={styles['taipei-city-parkinglot-binding']}>
          北市公有停車場車牌等待綁定中，需等待綁定完成後，隔日凌晨 4:00 起，才可使用車牌辨識自動繳費功能。
        </div>
      );
    } else if (bindingState === 'binding_failed') {
      if (hasPayments) {
        return (
          <div className={styles['taipei-city-parkinglot-binding']}>
            北市公有停車場車牌綁定失敗，請先移除其他平台車號設定後，點此重新綁定。
          </div>
        );
      } else {
        return (
          <div className={styles['taipei-city-parkinglot-binding']}>
            北市公有停車場車牌綁定失敗，請先設定您的付款方式。
          </div>
        );
      }
    } else {
      return null;
    }
  };

  return (
    <ButtonDialog
      title={`${licensePlate.plateNumber} / ${vehicleCarTypes[licensePlate.vehicleType]}`}
      items={[
        {
          content: '確定',
          theme: 'positive',
          onClick: close,
        },
      ]}
      isShow={isShow}
    >
      {taipeiCityParkinglotBinding(state.bindingState)}
    </ButtonDialog>
  );
};

export default LicensePlateDialog;
